import Typography from "@mui/material/Typography";
import { useMemo } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  ENTERPRISE_ADLE_MODULES_OPTIONS,
  ENTERPRISE_PRIMARY_GOAL_OPTIONS,
} from "../../../utils/constants";
import {
  ENTERPRISE_INTAKE_FIELD_PRIMARY_GOAL,
  ENTERPRISE_INTAKE_FIELD_SELECTED_ADLE_MODULES,
  ENTERPRISE_INTAKE_HINT_SECTION_02_MODULES,
} from "../../../i18n/keysTranslations";
import CheckGroup from "../../PreActivation/components/CheckGroup";
import FieldBlock from "../../PreActivation/components/FieldBlock";
import FieldError from "../../PreActivation/components/FieldError";
import FieldLabel from "../../PreActivation/components/FieldLabel";
import ReadOnlySectionGrid from "../../PreActivation/components/ReadOnlySectionGrid";
import RadioWithOtherField from "./shared/RadioWithOtherField";
import { mapTranslatedOptions } from "./shared/mapTranslatedOptions";

const ModuleSelectorSection = ({ control, errors, readOnly }) => {
  const { t } = useTranslation();

  const moduleOptions = useMemo(
    () => mapTranslatedOptions({ options: ENTERPRISE_ADLE_MODULES_OPTIONS, t }),
    [t]
  );

  const primaryGoalOptions = useMemo(
    () => mapTranslatedOptions({ options: ENTERPRISE_PRIMARY_GOAL_OPTIONS, t }),
    [t]
  );

  return (
    <ReadOnlySectionGrid readOnly={readOnly}>
      {!readOnly ? (
        <Typography
          component="p"
          sx={{
            gridColumn: "1 / -1",
            fontSize: "14px",
            color: "text.secondary",
            lineHeight: 1.6,
            mb: 1,
          }}
        >
          {t(ENTERPRISE_INTAKE_HINT_SECTION_02_MODULES)}
        </Typography>
      ) : null}

      <FieldBlock>
        <FieldLabel
          htmlFor="selectedAdleModules"
          text={t(ENTERPRISE_INTAKE_FIELD_SELECTED_ADLE_MODULES)}
          required
        />
        <Controller
          name="selectedAdleModules"
          control={control}
          render={({ field, fieldState }) => (
            <>
              <CheckGroup
                name="selectedAdleModules"
                options={moduleOptions}
                selectedValues={field.value}
                onChange={field.onChange}
                readOnly={readOnly}
              />
              <FieldError message={fieldState.error?.message} />
            </>
          )}
        />
      </FieldBlock>

      <RadioWithOtherField
        name="primaryGoal"
        otherName="primaryGoalOther"
        labelKey={ENTERPRISE_INTAKE_FIELD_PRIMARY_GOAL}
        required
        options={primaryGoalOptions}
        control={control}
        errors={errors}
        readOnly={readOnly}
      />
    </ReadOnlySectionGrid>
  );
};

export default ModuleSelectorSection;
